import { render, staticRenderFns } from "./changeFamily.vue?vue&type=template&id=2b19808a&scoped=true&"
import script from "./changeFamily.vue?vue&type=script&lang=js&"
export * from "./changeFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b19808a",
  null
  
)

export default component.exports